import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { BreadcrumbService } from './breadcrumb.service';
import { Breadcrumb } from './breadcrumb';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-breadcrumb',
    imports: [
        CommonModule,
        BreadcrumbModule,
        RouterModule
    ],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {

  breadcrumbItems$ = this.breadcrumbService.breadcrumbs$;

  constructor(
    public breadcrumbService: BreadcrumbService,
    private router: Router
  ) {}

  homeButton(): void {
    this.breadcrumbService.clearBreadcrumbs();
  }

  //Global styles for breadcrumb found in main.scss
  breadCrumb = {
    root: {
      padding: '0.5rem 1rem',
      background: '{surface.0}'
    },
    item: {
      color: '{primary.600}',
      gap: '0',
    }
  }

}
